import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery, { getSUMEntityToken } from '../root';

const baseUrl = 'https://api.super-user-manager.com/sum-connector/api';

const baseQuery = axiosBaseQuery({
  baseUrl,
});

export const SUMRTKService = createApi({
  reducerPath: 'SUMRTKService',
  baseQuery,
  tagTypes: ['SUMEntity', 'SUMEntityPreferences', 'SUMEntityCountUsers'],
  endpoints: builder => ({
    getEntity: builder.query<any, any>({
      query: ({ entityIdentification }: { entityIdentification: string }) => ({
        url: `/entity/${entityIdentification}`,
        method: 'GET',
        headers: {
          Authorization: getSUMEntityToken(),
        },
      }),
      transformResponse: (response: any) => response.element,
      providesTags: ['SUMEntity'],
    }),
    getEntityPreferences: builder.query<any, any>({
      query: ({ entityIdentification }: { entityIdentification: string }) => ({
        url: `/entity/${entityIdentification}/preferences`,
        method: 'GET',
        headers: {
          Authorization: getSUMEntityToken(),
        },
      }),
      transformResponse: (response: any) => response.element,
      providesTags: ['SUMEntityPreferences'],
    }),
    getEntityCountUsers: builder.query<any, any>({
      query: ({ entityIdentification }: { entityIdentification: string }) => ({
        url: `/entity/${entityIdentification}/stats/counter`,
        method: 'GET',
        headers: {
          Authorization: getSUMEntityToken(),
        },
      }),
      transformResponse: (response: any) => response.element,
      providesTags: ['SUMEntityCountUsers'],
    }),
  }),
});

export const { useGetEntityQuery, useGetEntityPreferencesQuery, useGetEntityCountUsersQuery } = SUMRTKService;
